import React, {Component} from 'react';
import Select from '@react/react-spectrum/Select';
import IntentDropdownScss from './IntentDropdown.scss';
import AppPickerUtil from '../../../../utils/AppPicker/AppPickerUtil';
import {DEFAULT_TASK_ID} from '../../../../constants/AppPicker/appPickerConstants';
import FieldLabel from '@react/react-spectrum/FieldLabel';

export default class IntentDropdown extends Component {
	renderCategoryDropdown = () => {
		const {
			categoryTaskData,
			onCategorySelect,
			selectedCategoryId,
			renderOnlyCategories,
			intl: {
				formatMessage
			}
		} = this.props;
		const dropdownList = categoryTaskData && categoryTaskData.map(category =>
			({
				label: category.name,
				value: category.id
			}));
		const className = renderOnlyCategories ? IntentDropdownScss.intentDropdown : IntentDropdownScss.dropdown;
		const menuClassName = renderOnlyCategories ? '' : IntentDropdownScss.dropdownMenu;
		return <Select
			className={className}
			menuClassName={menuClassName}
			onChange={onCategorySelect}
			options={dropdownList}
			value={selectedCategoryId}
			placeholder={formatMessage({id: 'apps.allAppsAppPicker.dropdown.select'})}
			quiet={!renderOnlyCategories} />;
	};

	renderTaskDropdown = () => {
		const {
			selectedTaskId,
			onTaskSelect,
			selectedCategoryId,
			intl: {
				formatMessage
			}
		} = this.props;
		const taskList = AppPickerUtil.getCategoryObjectFromCategoryId(selectedCategoryId).taskList;
		const dropdownList = taskList && taskList.filter(task => task.id !== `${DEFAULT_TASK_ID}-${selectedCategoryId}`).map(task =>
			({
				label: task.name,
				value: task.id
			}));
		return <Select
			className={IntentDropdownScss.dropdown}
			menuClassName={IntentDropdownScss.dropdownMenu}
			onChange={onTaskSelect} options={dropdownList}
			value={selectedTaskId}
			placeholder={formatMessage({id: 'apps.allAppsAppPicker.dropdown.select'})}
			quiet/>;
	};

	render() {
		const {
			intl: {
				formatMessage
			}
		} = this.props;
		/*
		Currently, renderOnlyCategories return true. The else part of the code implements
		the other variation where there might be a task dropdown too
		 */
		if (this.props.renderOnlyCategories) {
			return (
				<div className={IntentDropdownScss.onlyCategoryFilterContainer}>
					<FieldLabel
						label={formatMessage({id: 'apps.allAppsAppPicker.intent.categoryFilter.label'})}
						className={IntentDropdownScss.filterLabelContainer}
						labelFor={IntentDropdownScss.intentDropdown}
						aria-label={formatMessage({id: 'apps.allAppsAppPicker.intent.categoryFilter.label'})}
					/>
					{this.renderCategoryDropdown()}
				</div>
			);
		}
		return (
			<div className={IntentDropdownScss.outerAppPickerContainer}>
				<div className={IntentDropdownScss.appPickerContainer}>
					<span className={`${IntentDropdownScss.labelContainer}`}>
						{formatMessage({id: 'apps.allAppsAppPicker.intent.category.label'})}
					</span>
					{this.renderCategoryDropdown()}
					<span className={`${IntentDropdownScss.labelContainer}`}>
						{formatMessage({id: 'apps.allAppsAppPicker.intent.task.label'})}
					</span>
					{this.renderTaskDropdown()}
				</div>
			</div>
		);
	}
}
